import { io, Socket } from "socket.io-client";

const WS_URL = import.meta.env.VITE_WS_URL;
const cache = new Map<string, Socket>();

export function connectNotifications(token: string): Socket {
  if (cache.has(token)) return cache.get(token)!;

  const socket: Socket = io(`${WS_URL}/notifications`, {
    transports: ["websocket", "polling"],
    auth: { token },
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 500,
    reconnectionDelayMax: 5000,
    timeout: 20000,
  });

  cache.set(token, socket);
  return socket;
}
